/**
 * Get the Save & Compare API URL, with intelligent fallback for SSR/client-side rendering.
 *
 * Priority order:
 * 1. Server-injected window.saveAndCompareApi (for client-side after hydration)
 * 2. Server-side process.env.SAVE_AND_COMPARE_API_URL (for SSR)
 * 3. Development fallback URL
 */
export const saveApiUrl = (): string => {
  // Client-side: check for server-injected URL
  if (typeof window !== 'undefined' && window.saveAndCompareApi) {
    return window.saveAndCompareApi
  }

  // Server-side: use environment variable
  if (typeof process !== 'undefined' && process.env?.SAVE_AND_COMPARE_API_URL) {
    return process.env.SAVE_AND_COMPARE_API_URL
  }

  // Development fallback
  return 'https://api.saved-dev.product.which.co.uk'
}
